module.exports = __webpack_public_path__ + "img/blended-learning.399861d9.png";